import { useRef } from 'react';
import { Box } from '@chakra-ui/react';
import DatePicker from 'react-datepicker';

import { isCurrentWeek } from 'Helper/isCurrentWeek';
import { CalendarIcon, ChevronDownIcon } from 'Asset/icon';
import { Condition } from 'Component/others';

import 'react-datepicker/dist/react-datepicker.css';
import styles from './styles.module.css';

const FilterDatepicker = ({
  placeholder = 'DD/MM/YYYY',
  onChange,
  value,
  register,
  margin,
  className,
  minDate,
  maxDate,
  width = '168px',
  borderless = false,
  icon = 'calendar',
}) => {
  const ref = useRef(null);

  const onOpenDatePicker = () => ref.current.setOpen(true);

  return (
    <Box margin={margin} className={`${className || ''} ${styles['datepicker-component__container']} `} width={width}>
      <Box className={`datepicker-custom__container datepicker__container--dateonly`}>
        <DatePicker
          ref={ref}
          placeholderText={placeholder}
          selected={value}
          onChange={onChange}
          className={`${borderless ? styles['datepicker-custom--borderless'] : styles['datepicker-custom--border']} ${styles['datepicker-custom']} ${
            !!value && styles['datepicker-custom__active']
          }`}
          calendarClassName="datepicker__calendar"
          formatWeekDay={(day) => day.substring(0, 1)}
          dayClassName={(date) => (isCurrentWeek(date) ? 'highlight-week' : '')}
          dateFormat={'dd MMMM yyyy'}
          minDate={minDate}
          maxDate={maxDate}
          onKeyDown={(e) => {
            e.preventDefault();
          }}
          {...register}
        />

        <Condition statement={icon === 'calendar'}>
          <CalendarIcon className={styles['calendar__icon']} color="var(--color-neutral70)" size="22px" onClick={onOpenDatePicker} />
        </Condition>
        <Condition statement={icon === 'chevron'}>
          <ChevronDownIcon className={styles['chevron__icon']} color="var(--color-neutral70)" size="18px" onClick={onOpenDatePicker} />
        </Condition>
      </Box>
    </Box>
  );
};

export default FilterDatepicker;
